export default __webpack_public_path__ + "static/media/Eye_4_M_C4.19f11afd.svg";